import { VisualizatorSettings } from "./visualizator-settings";

export class ViewObjectSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    const copiedFileds = ["x", "y", "width", "height"];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "type") {
        this.type = settings.type;
      }
      if (copiedFileds.includes(key)) {
        this[key] = settings[key].copy();
      }
    }
  }

  copy() {
    return new ViewObjectSettings(this);
  }
}
